import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import RobotComparisonDashboardCard from '../../CleaningReportsDashboard/RobotComparisonDashboardCard';
import { calculateEfficiency } from './EfficiencyUtils';

const EXTRA_METRICS = [
    {
        value: 'efficiency',
        labelId:
            'page.robots.cleaning_report.robot_comparison.metrics.efficiency',
        fallback: 'Eficiência (m²/min)',
    },
];

export default function EfficiencyRobotComparisonCard({ data, ...rest }) {
    // Inject efficiency into data
    const enhancedData = useMemo(() => {
        if (!data) return [];
        return data.map(robotData => {
            // RobotData is expected to have tasks, time, area, frequency
            // The time is in hours, according to RobotComparisonDashboardLogic.js
            // but we need it in seconds for calculateEfficiency? No, wait!
            // Let's check RobotComparisonDashboardLogic.js. Wait, we don't have access to the raw seconds easily in `data`.
            // The area is `robotData.area` (m²) and time is `robotData.time` (hours).
            // So time in minutes is `robotData.time * 60`.
            const eff = calculateEfficiency(
                robotData.area,
                robotData.time * 60 * 60
            ); // calculateEfficiency expects seconds

            return {
                ...robotData,
                efficiency: eff ? Number(eff.toFixed(2)) : 0,
            };
        });
    }, [data]);

    return (
        <RobotComparisonDashboardCard
            {...rest}
            data={enhancedData}
            extraMetrics={EXTRA_METRICS}
        />
    );
}

EfficiencyRobotComparisonCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
};

EfficiencyRobotComparisonCard.defaultProps = {
    data: [],
};
